import React, { useEffect } from 'react';
import { CoreLoader } from '@komodo-design-system/komodo-components-react';
import './Loading.scss';
const Loading = () => {
  useEffect(() => {
    const body = document.querySelector('body');
    body.style.pointerEvents = 'none';
    body.style.overflow = 'hidden';
    return () => {
      body.style.pointerEvents = 'auto';
      body.style.overflow = 'auto';
    };
  }, []);
  return (
    <div className="loading">
      <CoreLoader variant="circular" size="small" className='loader' />
    </div>
  );
};
export default Loading;
